import { css } from 'styled-components';
import { colors, font } from '@chegg-ui/theme';
var dark = colors.dark;
var family = font.family,
  weight = font.weight,
  size = font.size;
export var Font = css(["color:", ";font-family:", ";font-weight:", ";font-size:", ";"], dark, family.aspira, weight.normal, size.px14);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/common/styled/common.js
// module id = 494
// module chunks = 11